import { useContext } from 'react';
import { useStore } from 'zustand';

import { WaterfallZoomContext } from './WaterfallZoomContext';

export interface WaterfallZoomState {
  zoomWidth: number;
  setZoomWidth: (width: number) => void;
  containerWidth: number;
  setContainerWidth: (width: number) => void;
  zoomIn: () => void;
  zoomOut: () => void;
  resetZoom: () => void;
}

const ZOOM_FACTOR = 1.3;

// Factory function to create new store instances
export const storeFactory = (set) => ({
  zoomWidth: 0,
  setZoomWidth: (width: number) => set({ zoomWidth: width }),
  containerWidth: 0,
  setContainerWidth: (width: number) => set({ containerWidth: width }),
  zoomIn: () =>
    set((state: WaterfallZoomState) => {
      const newWidth = state.zoomWidth * ZOOM_FACTOR;
      return {
        zoomWidth:
          newWidth > state.containerWidth ? newWidth : state.containerWidth,
      };
    }),
  zoomOut: () =>
    set((state: WaterfallZoomState) => {
      const newWidth = state.zoomWidth / ZOOM_FACTOR;
      return {
        zoomWidth:
          newWidth > state.containerWidth ? newWidth : state.containerWidth,
      };
    }),
  resetZoom: () =>
    set((state: WaterfallZoomState) => ({ zoomWidth: state.containerWidth })),
}); // Hook to use the waterfall zoom state from context

export const useWaterfallZoomState = <U,>(
  selector: (state: WaterfallZoomState) => U
): U => {
  const store = useContext(WaterfallZoomContext);
  if (!store) {
    throw new Error(
      'useWaterfallZoomState must be used within a WaterfallZoomProvider'
    );
  }
  return useStore(store, selector);
}; // Context to provide the store instance
